import {createFileRoute, Outlet, redirect, useLocation} from '@tanstack/react-router';
import {PATHOLOGY_CUSTOMIZATION_LIST} from '@/practitioner/routing/paths';
import {companyAdminGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';
import PathologyCustomizationList from '@/practitioner/views/company/PathologyCustomization/PathologyCustomizationList';
import {AppRouterContext} from '@/shared/routing';
import {USER_HOME} from '@/shared/routing/paths';

const PathologyCustomizationLayout = () => {
  const {pathname} = useLocation();
  const isRoot = pathname === PATHOLOGY_CUSTOMIZATION_LIST;
  return isRoot ? <PathologyCustomizationList /> : <Outlet />;
};

export const Route = createFileRoute('/(practitioner)/company/pathology-customization')({
  component: PathologyCustomizationLayout,
  beforeLoad: function ({context}: {context: AppRouterContext}) {
    if (context.company?.isForClinicalTrials) {
      throw redirect({to: USER_HOME, replace: true});
    }
    grantUser(companyAdminGranted)({context, location: {pathname: PATHOLOGY_CUSTOMIZATION_LIST}});
  }
});
